import { redirect } from 'react-router-dom';

import { MFAAuthRequest, postLoginMFA } from '../../queries/usePostMFALogin.ts';

export type ProcessingMFALoaderData = {
  mfaError: boolean;
};

export const JWTSubmitMFA = async ({ request }: { request: Request }) => {
  const requestUrl = new URL(request.url);
  const hash = requestUrl.hash || window.location.hash || '';
  const cleanedHash = hash.replace(/^#/, '');
  const params = new URLSearchParams(cleanedHash);
  const authToken = { id_token: params.get('id_token') } as MFAAuthRequest;

  if (!authToken.id_token) {
    return { mfaError: true } as ProcessingMFALoaderData;
  }

  try {
    await postLoginMFA(authToken);
    return redirect('/prequalification');
  } catch (error) {
    console.error('Dealer MFA login failed', error);
    return { mfaError: true } as ProcessingMFALoaderData;
  }
};
